import { auth, db, signOut, getDoc } from "./main.js";
import { formatDate, page,   showCustomLoadingOverlay,
  hideCustomLoadingOverlay, showCustomLoadingOverlayMain, hideCustomLoadingOverlayMain } from "./utilities.js";
import {
  signInWithRedirect,
  getRedirectResult,
  GoogleAuthProvider,
  OAuthProvider,
  getAdditionalUserInfo,
  onAuthStateChanged,
} from "firebase/auth";
import { collection, setDoc, doc, serverTimestamp } from "firebase/firestore";
var packageOption = "";
const termsCheckbox = document.getElementById("termsCheckbox");
const btnGoogle = document.querySelector("#registerWithGoogle");
const btnApple = document.querySelector("#registerWithApple");
const btnGoogleMember = document.querySelector("#loginWithGoogleMember");
const btnAppleMember = document.querySelector("#loginWithAppleMember");
export const btnLogout = document.querySelector("#logout");
export const btnLogin = document.querySelector("#login");
export const btnRegister = document.querySelector("#register");
export const btnProfile = document.querySelector("#profile");
export const btnFaq = document.querySelector("#faq");
export const btnSupport = document.querySelector("#supportOption");
const alreadyExist = document.getElementById("accountExist");
if (page === "/missing/login.html") {
  document.addEventListener("DOMContentLoaded", async function () {
    showCustomLoadingOverlay();
    await Promise.all([checkAuthStateLogin(), loadPageResourcesLogin()]);
    hideCustomLoadingOverlay();
    function checkAuthStateLogin() {
      return new Promise((resolve) => {
        onAuthStateChanged(auth, async (user) => {
          const isSocialLogin =
            localStorage.getItem("isSocialLogin") === "true"; // Check flag
          if (user && isSocialLogin) {
            await handleGoogleAppleLogin(user); // Process user registration
            localStorage.removeItem("isSocialLogin");
          }
          resolve(); // Resolve the promise after processing the auth state
        });
      });
    }

    function loadPageResourcesLogin() {
      return new Promise((resolve) => {
        setTimeout(() => {
          console.log("Page resources loaded");
          resolve(); // Simulate resources being loaded
        }, 1000); // Simulate a 1-second loading time
      });
    }
  });
}

if (page === "/missing/register.html") {
  document.addEventListener("DOMContentLoaded", async function () {
    showCustomLoadingOverlay();
    await Promise.all([checkAuthState(), loadPageResources()]);
   hideCustomLoadingOverlay();
    // Get the URL parameters
    // const urlParams = new URLSearchParams(window.location.search);

    // // Get the value of the 'report' parameter
    // const report = urlParams.get("report");
    // console.log(report);
    // if (report) {
    //   // Use the 'report' variable in your code
    //   if (report === "lost") {
    //     packageOption = "lost";
    //   } else if (report === "found") {
    //     packageOption = "found";
    //   }
    // }

    function checkAuthState() {
      return new Promise((resolve) => {
        onAuthStateChanged(auth, async (user) => {
          const isSocialLogin =
            localStorage.getItem("isSocialLogin") === "true"; // Check flag
          if (user && isSocialLogin) {
            await handleGoogleAppleRegistration(user); // Process user registration
            localStorage.removeItem("isSocialLogin");
          }
          resolve(); // Resolve the promise after processing the auth state
        });
      });
    }

    function loadPageResources() {
      return new Promise((resolve) => {
        setTimeout(() => {
          //console.log("Page resources loaded");
          resolve(); // Simulate resources being loaded
        }, 1000); // Simulate a 1-second loading time
      });
    }
    //registerMemberInit();

    // Function to show the modal
    function showModal() {
      const modal = document.getElementById("questionModal");
      if (modal) {
        modal.style.display = "block";
      }
    }
    // Event delegation to handle modal open link click
    document.addEventListener("click", function (event) {
      const target = event.target;
      if (target && target.id === "questionModalButton") {
        event.preventDefault(); // Prevent the default link behavior
        gtag("event", "Registration Question Modal", {
          event_category: "Question Modal Interaction",
          event_label: "Question Modal Open Link Clicked",
        });
        showModal(); // Show the modal
      }
    });

    // Event delegation to handle modal close button click
    document.addEventListener("click", function (event) {
      const target = event.target;
      if (target && target.id === "modal-close-btn") {
        const modal = document.getElementById("questionModal");
        if (modal) {
          modal.style.display = "none"; // Hide the modal
        }
      }
    });

    // Event delegation to close the modal if the user clicks outside of it
    window.addEventListener("click", function (event) {
      const modal = document.getElementById("questionModal");
      if (modal && event.target === modal) {
        modal.style.display = "none"; // Hide the modal
      }
    });
  });
}

/******REGISTER BUTTONS******/
// if (btnGoogle) {
//   btnGoogle.addEventListener("click", (e) => {
//     e.preventDefault();
//     registerGoogle();
//   });
// }

// if (btnApple) {
//   btnApple.addEventListener("click", (e) => {
//     e.preventDefault();
//     registerApple();
//   });
// }
function validateTermsAgreement() {
  if (!termsCheckbox.checked) {
    alert("Please confirm that you have read the Terms of Service and Privacy Policy.");
    return false;
  }
  return true;
}

if (btnGoogle) {
  btnGoogle.addEventListener("click", function (event) {
    event.preventDefault();
    if (validateTermsAgreement()) {
      registerGoogle();
    }
  });
}

if (btnApple) {
  btnApple.addEventListener("click", function (event) {
    event.preventDefault();
    if (validateTermsAgreement()) {
      registerApple();
    }
  });
}
/******END REGISTER BUTTONS******/

/******LOGIN BUTTONS******/
if (btnGoogleMember) {
  btnGoogleMember.addEventListener("click", (e) => {
    e.preventDefault();
    loginGoogleMember();
  });
}

if (btnAppleMember) {
  btnAppleMember.addEventListener("click", (e) => {
    e.preventDefault();
    loginAppleMember();
  });
}
/******END LOGIN BUTTONS******/

/*************REGISTER GOOGLE / APPLE *****************/
function registerGoogle() {
  const googleProvider = new GoogleAuthProvider();
  showCustomLoadingOverlay();
  localStorage.setItem("isSocialLogin", "true");
  signInWithRedirect(auth, googleProvider);
}

function registerApple() {
  const appleProvider = new OAuthProvider("apple.com");
  showCustomLoadingOverlay();
  localStorage.setItem("isSocialLogin", "true");
  signInWithRedirect(auth, appleProvider);
}
/*************END REGISTER GOOGLE / APPLE ***************/

/*************LOGIN GOOGLE / APPLE *****************/
function loginGoogleMember() {
  const googleProvider = new GoogleAuthProvider();
  showCustomLoadingOverlay();
  localStorage.setItem("isSocialLogin", "true");
  signInWithRedirect(auth, googleProvider);
}

function loginAppleMember() {
  const appleProvider = new OAuthProvider("apple.com");
  showCustomLoadingOverlay();
  localStorage.setItem("isSocialLogin", "true");
  signInWithRedirect(auth, appleProvider);
}
/*************END LOGIN GOOGLE / APPLE *****************/

async function loginMemberInit() {
  showCustomLoadingOverlay();
  const result = await getRedirectResult(auth);
  // Process the redirect result
  if (result && result.user) {
    showCustomLoadingOverlay();
    const credential = OAuthProvider.credentialFromResult(result);
    const additionalUserInfo = getAdditionalUserInfo(result);
    const isNewUser = additionalUserInfo.isNewUser;

    if (credential) {
      const accessToken = credential.accessToken;
      const idToken = credential.idToken;
      const user = result.user;
      const operationType = result.operationType;
      const userDisplayName = user.displayName;
      const userSignInEmail = user.email;
      const userId = user.uid;
      const credProvider = credential.providerId;

      if (isNewUser) {
        hideCustomLoadingOverlay();
        $("#loginError").text("Account not found. Please register first.");
        await auth.currentUser.delete();
      } else {
        displayMemberProfile(userId);
      }
    }
  } else {
    // Redirect was not successful or no user is logged in
    // Handle the unsuccessful redirect or logged-out state
    hideCustomLoadingOverlay();
  }
}

async function handleGoogleAppleLogin(user) {
  displayMemberProfile(user.uid);
}

// Function to handle Google or Apple registration
async function handleGoogleAppleRegistration(user) {
  showCustomLoadingOverlay();
  try {
          // Get the value of the 'report' parameter
          const urlParams = new URLSearchParams(window.location.search);
          const report = urlParams.get("report");
          console.log(report);
          if (report) {
            // Use the 'report' variable in your code
            if (report === "lost") {
              packageOption = "lost";
            } else if (report === "found") {
              packageOption = "found";
            }
          }
    const accountsRef = collection(db, "accounts");
    const userDocRef = doc(accountsRef, user.uid);

    // Check if user already exists in Firestore
    const docSnap = await getDoc(userDocRef);
    if (docSnap.exists()) {
      alreadyExist.textContent =
        "Account already exists. Please login instead.";
      alreadyExist.classList.remove("d-none");
    } else {
      createProfile(
        user.uid,
        user.displayName,
        user.email,
        user.providerId,
        packageOption
      );
      console.log(user);
    }
  } catch (error) {
    console.error("Error handling user registration:", error);
  } finally {
   hideCustomLoadingOverlay();
  }
}

async function registerMemberInit() {
  showCustomLoadingOverlay();
  const result = await getRedirectResult(auth);
  // Process the redirect result
  if (result && result.user) {
    showCustomLoadingOverlay();
    const credential = OAuthProvider.credentialFromResult(result);
    const additionalUserInfo = getAdditionalUserInfo(result);
    const isNewUser = additionalUserInfo.isNewUser;

    if (credential) {
      const accessToken = credential.accessToken;
      const idToken = credential.idToken;
      const user = result.user;
      const operationType = result.operationType;
      const userDisplayName = user.displayName;
      const userSignInEmail = user.email;
      const userId = user.uid;
      const credProvider = credential.providerId;

      if (isNewUser) {
        createProfile(
          userId,
          userDisplayName,
          userSignInEmail,
          credProvider,
          packageOption
        );
      } else {

        hideCustomLoadingOverlay();
        $("#loginError").text(
          "Account already exist. Please login to your existing account on the login page."
        );
      }
    }
  } else {
    // Redirect was not successful or no user is logged in

    hideCustomLoadingOverlay();
  }
}

function createProfile(
  uid,
  userDisplayName,
  userSignInEmail,
  credProvider,
  packageOption
) {
  showCustomLoadingOverlayMain();
  const docRef = doc(db, "accounts", uid);
  getDoc(docRef)
    .then((docSnap) => {
      if (docSnap.exists()) {
        $("#accountExist").text(
          "Account already exist. Please login on the login page."
        );
        hideCustomLoadingOverlay();
      } else {
        // Create a user in the database with their uid from auth
        setDoc(docRef, {
          name: userDisplayName,
          email: userSignInEmail,
          paidMember: false,
          provider: credProvider,
          uid: uid,
          hasListing: false,
          premiumMember: false,
          packageType: packageOption,
          memberProgress: "Submission",
          memberSince: serverTimestamp(),
          status: "inactive",
          plan: "",
          active: false,
        });

        const userName = userDisplayName;
        const userEmail = userSignInEmail;
        const hasListing = false;
        const paidMember = false;
        const premiumMember = false;
        const signInFrom = credProvider;
        const packageType = packageOption;
        const memberProgress = "Submission";
        const today = new Date();
        const memberSince = formatDate(today);
        const status = "inactive";
        const plan = "";

        setTimeout(function () {
          // CREATE PHP SESSION
          userSession(
            uid,
            userName,
            userEmail,
            hasListing,
            paidMember,
            premiumMember,
            signInFrom,
            packageType,
            memberProgress,
            memberSince,
            status,
            plan
          );
        }, 2000);
      }
    })
    .catch((error) => {
      console.log(error);
      hideCustomLoadingOverlayMain();
    });
}

function displayMemberProfile(uid) {
  getDoc(doc(db, "accounts", uid)).then((docSnap) => {
    if (docSnap.exists()) {
      const docdata = docSnap.data();
      const userName = docdata.name;
      const userEmail = docdata.email;
      const hasListing = docdata.hasListing;
      const paidMember = docdata.paidMember;
      const premiumMember = docdata.premiumMember;
      const signInFrom = docdata.provider;
      const packageType = docdata.packageType;
      const memberProgress = docdata.memberProgress;
      const status = docdata.status;
      const memberSince = formatDate(docdata.memberSince.toMillis());
      const plan = docdata.plan;

      setTimeout(function () {
        // CREATE PHP SESSION
        userSession(
          uid,
          userName,
          userEmail,
          hasListing,
          paidMember,
          premiumMember,
          signInFrom,
          packageType,
          memberProgress,
          memberSince,
          status,
          plan
        );
      }, 1000);
    } else {
      // USER IS NOT A MEMBER
      noAccountFound();
    }
  });
}

function noAccountFound() {
  // USER IS NOT A MEMBER
  const currentUser = auth.currentUser;

  // Load deleteUser function only when it's needed
  import("firebase/auth")
    .then((firebaseAuth) => {
      const deleteUser = firebaseAuth.deleteUser;
      deleteUser(currentUser);
    })
    .catch((err) => {
      console.log("Failed to load firebase/auth", err);
    });

  signOut(auth);
  hideCustomLoadingOverlay();
  $("#loginError").text("Account not found. Please register first.");
}

function userSession(
  uid,
  userName,
  userEmail,
  hasListing,
  paidMember,
  premiumMember,
  signInFrom,
  packageType,
  memberProgress,
  memberSince,
  status,
  plan
) {
  $.ajax({
    method: "get",
    url: "../missing/functions/userAccounts.php",
    data: {
      uid: uid,
      userName: userName,
      userEmail: userEmail,
      hasListing: hasListing,
      paidMember: paidMember,
      premiumMember: premiumMember,
      signInFrom: signInFrom,
      packageType: packageType,
      memberProgress: memberProgress,
      memberSince: memberSince,
      status: status,
      plan: plan,
    },
    success: function (data) {
      $("#data").text(data);
        hideCustomLoadingOverlayMain();
        switch (memberProgress) {
          case "Submission":
            // Functionality
            console.log(
              "Your current progress is " +
                memberProgress +
                " so go to the post.html " +
                packageType
            );
            if (packageType == "found") {
              location = "post-found.html";
            } else {
              location = "post.html";
            }
            break;
          case "Complete":
            // Functionality
            location = "profile.html";

            break;
          default:
            Functionality;
            location = "noaccount.html";
            break;
        }
    },
    error: function (xhr, textStatus, error) {
      console.log(xhr.statusText);
      console.log(textStatus);
      console.log(error);
      console.log("PHP Session error");
    },
  });
}
